import { BrunchDate } from '../utils';

const brunchDate = (timestamp) => {
    if (timestamp) {
        return BrunchDate(timestamp);
    }

    return timestamp;
};

export default brunchDate;
